export default __webpack_public_path__ + "static/media/offer1.7e2a9dae.jpg";